import React from 'react'
import pharmaWork from '../components/images/pharma-work.jpg';
function VideoIntro() {
  return (
    <>
    <div className='video-intro' >
        <ul>
        <li>
            <img src={pharmaWork}/>
        </li>
        <li>
            <div className='video-intro-content'>
                <h4>We are Truested by World's Leading Companies</h4>
                 <ul>
                    <li>
                    <p>At the core of our business is a deep and unwavering commitment to earning the trust of the world’s most recognized companies. Our journey to becoming a trusted partner of global industry leaders has been shaped by our dedication to delivering consistently reliable, innovative, and future-proof solutions. From cutting-edge technology to seamless user experiences, we work tirelessly to meet the complex and evolving needs of our clients. By aligning ourselves with the goals and visions of these esteemed organizations, we have established long-standing relationships that have become the cornerstone of our success.</p>
                    <p>Our clients choose us not only for our technical expertise but for our ability to understand their industries and provide strategic insights that help drive their business forward. Whether it's in technology, finance, healthcare, or manufacturing, we understand that no two industries are the same, and that’s why we tailor our approach to each client. We take the time to deeply understand their business, challenges, and opportunities so that our solutions are not just effective but transformative</p>


                    </li>
                 </ul>
            </div>
        </li>
        </ul>
    </div>
    
    </>
  )
}

export default VideoIntro